/* Copyright (c) 2026 PearlCrm Pty Ltd. All rights reserved. */

import { FONT_MONO, monoTabularProps } from "styles/tokens/typography";

const typography = {
  styleOverrides: {
    root: ({ ownerState }) => {
      if (ownerState.variant === "mono" || ownerState.variant === "code") {
        return {
          fontFamily: FONT_MONO,
          fontWeight: 400,
          ...monoTabularProps,
        };
      }
      return {};
    },
  },
  defaultProps: {
    variantMapping: {
      mono: "span",
      code: "code",
    },
  },
};

export default typography;
